import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=3a395804"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports